/**
 * Constants for Instance Status IDs.
 * Mirror of api/db/secondary/instanceStatusConstants.js
 */
export const INSTANCE_STATUS = {
  NULL: 0,
  AVAILABLE: 1,
  NOT_FOR_SALE: 2,
  SOLD: 3,
  ON_HOLD: 4,
  CONSIGNED: 5,
  RETURNED: 7,
  DESTROYED: 8,
  INACTIVE: 9,
  TO_BE_INVOICED: 10,
  PENDING: 11,
  INSTALLATION: 12,
  ALLOCATED: 13,
  UNCONFIRMED: 14,
  TO_BE_RETURNED: 15,
};
